// extracted by mini-css-extract-plugin
export default {"root":"App_root__nZZtU","app":"App_app__GuJBs"};